import React from "react";
import type {VoidFunctionComponent} from "react";
import s from "./FilterGenres.module.scss";
import {useFilterGenresLogic} from "./FilterGenres.logic";
import {FilterGenre} from "../filter-genre/FilterGenre";
import {FilterGenreControls} from "../filter-genre-controls/FilterGenreControls";

export const FilterGenres: VoidFunctionComponent = () => {
  const {isAvailable, genreIds} = useFilterGenresLogic();
  if (!isAvailable){
    // not available for filter
    return null;
  }
  return (
    <ol className={s.container}>
      <li>
        <FilterGenreControls />
      </li>
      {genreIds.map((genreId) => <FilterGenre {...{genreId}} key={`filter-genre-${genreId}`} />)}
    </ol>
  );
}
